import { createPaginatedKey } from "api/keys";
import { UUID } from "api/types";

export const wmsRampKeys = {
  list: createPaginatedKey("ramps"),
  details: (id: UUID) => ["ramp", id],
};
